import { template as template_85dc8725bb3c4998957b2ceaa22e5053 } from "@ember/template-compiler";
import Component from '@glimmer/component';
import FilterWrapper from 'eflex/components/filters/filter-wrapper';
import { findBy } from '@eflexsystems/ember-composable-helpers';
import { isPresent } from '@ember/utils';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import Portal from 'ember-stargate/components/portal';
import SearchTag from 'eflex/components/filters/search-tag';
import { or } from 'ember-truth-helpers';
import TaskStatuses from 'eflex/constants/task-statuses';
export default class PassFailFilter extends Component {
    @service
    intl;
    @tracked
    isDisplayed;
    constructor(){
        super(...arguments);
        this.isDisplayed = Boolean(this.args.passed);
        this.args.initParam('passed', this.args.passed);
    }
    get searchTagPassFail() {
        if (this.args.status == TaskStatuses.SCRAPPED) {
            return 'Scrapped';
        } else {
            return this.args.passed === 'true' ? 'Passed' : 'Failed';
        }
    }
    get options() {
        const options = [
            {
                label: this.intl.t('passed'),
                value: 'true'
            },
            {
                label: this.intl.t('failed'),
                value: 'false'
            }
        ];
        if (this.isBuildHistory) {
            options.push({
                label: this.intl.t('scrapped'),
                value: TaskStatuses.SCRAPPED
            });
        }
        return options;
    }
    get passed() {
        return this.args.getParam('passed');
    }
    get isBuildHistory() {
        return this.args.isBuildHistory;
    }
    onDisplayedChanged = ()=>{
        this.isDisplayed = !this.isDisplayed;
    };
    get selectedOption() {
        if (this.args.getParam('status') == TaskStatuses.SCRAPPED) {
            return TaskStatuses.SCRAPPED;
        } else {
            return this.args.getParam('passed');
        }
    }
    onSelected = (selected)=>{
        if (selected?.label === this.intl.t('scrapped')) {
            this.args.updateParam('status', TaskStatuses.SCRAPPED);
            this.args.updateParam('passed', null);
        } else {
            this.args.updateParam('passed', selected?.value);
            this.args.updateParam('status', null);
        }
    };
    clear = ()=>{
        this.args.updateParam('passed', null);
        this.args.updateParam('status', null);
    };
    static{
        template_85dc8725bb3c4998957b2ceaa22e5053(`
    <Portal @target="filter-fields">
      <FilterWrapper
        class="eflex-pass-fail-criteria"
        @form={{@form}}
        @label={{if this.isBuildHistory "status" "controls.criteria.passfail"}}
        @isDisplayed={{this.isDisplayed}}
        @onChecked={{this.onDisplayedChanged}}
        @hasValue={{isPresent this.selectedOption}}
        @clear={{this.clear}}
        ...attributes
      >
        <@form.element
          @controlType="power-select"
          @options={{this.options}}
          @optionLabelPath="label"
          @onChange={{this.onSelected}}
          @value={{findBy "value" this.selectedOption this.options}}
        as |el|>
          <el.control class="sm" />
        </@form.element>
      </FilterWrapper>
    </Portal>
    <Portal @target="search-badge-tags">
      <SearchTag
        class='passFail'
        @isDisplayed={{or @passed @status}}
        @text={{this.searchTagPassFail}}
      />
    </Portal>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
